(function($) {

   function resizeDirectionsModal(){
      // Get the width of the browser including the scrollbar
      $('body').css('overflow', 'hidden');
      var windowWidth = $(window).width();
      $('body').css('overflow', 'auto');
      if(windowWidth < 768){
         maxHeight = $(window).height() - $('#directionsModal .modal-header').outerHeight() - 20;
      }else{
         maxHeight = $(window).height() - $('#directionsModal .modal-header').outerHeight() - 80;
      }
      $('#directionsModal .modal-body').css({
         maxHeight: maxHeight,
         overflow: 'scroll'
      });
   }

   //-------------------------------------------
   //MatchHeight these elements
   //-------------------------------------------
   function matchHeightAll() {
      var match_selectors = [
         '.feature-box'
      ];

      if ($(window).width() > 767) {
         for (var i=0; i < match_selectors.length; i++) {
            $(match_selectors[i]).matchHeight({byRow:false});
         }
      }
   }

   //-------------------------------------------
   //Set dimension of elements
   //-------------------------------------------
   function setDimensions() {
      $('.home-banner, .home-banner .slider-item').height($(window).height() - $('header').height());
   }

   $(document).ready(function(){

      $('.disc_button').click(function() {
         $('html,body').animate({
             scrollTop: $('#welcome').offset().top
         }, 800);
      });

      $('header .icon-search').click(function() {
         $('.search-holder').slideToggle();
      });

      $('.search-holder .close').click(function(){
         $('.search-holder').slideUp();
      });

      //-------------------------------------------
   	//Initialize Home Banner
   	//-------------------------------------------
   	$('#home-banner').owlCarousel({
   		items:1,
   		margin:0,
   		loop:true,
   		autoplay:true,
   		autoplayTimeout : 5500,
   		autoplaySpeed:700,
         nav:false,
         dots:true,
         dotsContainer: '#discover .dots'
   	});


      //-------------------------------------------
   	//Initialize Testimonial Banner
   	//-------------------------------------------
   	$('#testimonial-slider.owl-carousel').owlCarousel({
   		items:1,
   		margin:0,
   		loop:true,
   		autoplay:true,
   		autoplayTimeout : 5500,
   		autoplaySpeed:700,
         nav:false,
         dots:true,
         dotsContainer: '#test-dots'
   	});

      //-------------------------------------------
   	//Initialize Services Banner
   	//-------------------------------------------
   	$('#services-slider').owlCarousel({
   		items:3,
   		margin:70,
   		loop:true,
   		autoplay:true,
   		autoplayTimeout : 5500,
   		autoplaySpeed:700,
         nav:false,
         dots:true,
         dotsContainer: '#services-dots',
         responsive: {
            0: {
               items:2,
               margin:30
            },
            992: {
               items:3,
               margin:70
            }
         }
   	});


      $('#viewmore').click(function(){
         $('#services-list .service-box').addClass('showed');
         $(this).hide();
      });


      $('#directionTextToggle').click(function(){
         $('#directionsModal .modal-body').html($('#directionsPanel').html());
         $('#directionsModal').modal('show');
         setTimeout(function(){
            resizeDirectionsModal();
         },200);
      });

      //-------------------------------------------
      //Search Toggle
      //-------------------------------------------
      $('#search-toggle').click(function(){
         $('#top-search').slideToggle();
         $(this).toggleClass('active');
      });

      $('.burger-btn').click(function(){
         $(this).toggleClass('opened');
         $('#responsive-menu').slideToggle();
      });

      matchHeightAll();

   });

   $(window).load(function(){
      setDimensions();
      $('.initial-hidden').css('opacity',1);
   });

   $(window).resize(function() {
      setDimensions();
      resizeDirectionsModal();
   });


})(jQuery); // Fully reference jQuery after this point.
